import { render, staticRenderFns } from "./VendorMemo.vue?vue&type=template&id=0c698056&"
import script from "./VendorMemo.vue?vue&type=script&lang=js&"
export * from "./VendorMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports